import type { PublicCheckout } from './contract';

export type CheckoutSkin = 'new' | 'legacy';

export function checkoutSkinFor(checkout: PublicCheckout): CheckoutSkin {
  return checkout.experiment?.variant === 'legacy' ? 'legacy' : 'new';
}
